"use client";

import { useState } from "react";
import type { TrainingSessionState } from "@/lib/types/training";
import { UserPreferences } from "./user-preferences";
import { SessionRoom } from "./session-room";
import { TrainingFinal } from "./training-final";

type TrainingFlowProps = {
  sessionId: string;
  trainingId: string;
  initialState?: TrainingSessionState;
};

export function TrainingFlow({
  sessionId,
  trainingId,
  initialState = "initial",
}: TrainingFlowProps) {
  const [state, setState] = useState<TrainingSessionState>(initialState);
  const [timerSeconds, setTimerSeconds] = useState(600); // 10 minutes

  const handleReady = () => {
    setState("started");
  };

  const handleEndSession = () => {
    setState("finished");
  };

  // Render based on current state
  switch (state) {
    case "initial":
    case "ready":
      return <UserPreferences onReady={handleReady} />;

    case "started":
      return (
        <SessionRoom
          timerSeconds={timerSeconds}
          onEndSession={handleEndSession}
        />
      );

    case "finished":
      return <TrainingFinal sessionId={sessionId} trainingId={trainingId} />;

    case "media-error":
      return (
        <div className="w-full max-w-[600px] mx-auto px-5 py-16 text-center">
          <h2 className="text-2xl font-bold text-[#ff3b3b] mb-4">
            Media Access Error
          </h2>
          <p className="text-[#6b7280]">
            We couldn't access your camera or microphone. Please check your
            browser permissions and try again.
          </p>
        </div>
      );

    default:
      return null;
  }
}
